import styled from 'styled-components';
import { Retry } from '@components/common';

export const TableWrapper = styled.div`
  width: auto;
  min-height: auto;
  height: 100%;
  flex: 1;
  margin: 10px 15px;

  .BaseTable__body {
    .BaseTable__row:hover,
    .BaseTable__row--hovered {
      background-color: #fff;
    }
  }
`;

export const BaselineTableWrapper = styled(TableWrapper)`
  top: 0.5em;
  flex: none;
  max-height: 120px;
`;

export const MarginDiv = styled.div`
  margin-left: 15px !important;
  margin-right: 15px !important;
`;

export const LoadingWrapper = styled(Retry)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
